import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, CheckCircle2, SendIcon, Camera, Smartphone, Dog, Gift, Percent, TrendingUp, BookOpen, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function CreatorProgram() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    petType: '',
    socialHandle: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const response = await fetch('https://api.pawchi.app/api/creator-applications', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formState.name,
          email: formState.email,
          pet_kind: formState.petType,
          social_media_link: formState.socialHandle
        })
      });
      if (!response.ok) {
        throw new Error('Failed to submit application. Please try again.');
      }
      setSubmitted(true);
      setFormState({
        name: '',
        email: '',
        petType: '',
        socialHandle: ''
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  }
  return <div className="min-h-screen bg-cream" data-id="element-772" data-mp="1pwigg8cnhf50">
      <div className="max-w-4xl mx-auto px-6 pt-32 pb-20" data-id="element-773" data-mp="1uv3a1oxed0kh">
        <Link to="/" className="inline-flex items-center gap-2 text-warmBrown/60 hover:text-peach transition-colors mb-8 font-medium" data-id="element-774" data-mp="1uts35g8nncp5">
          <ArrowLeftIcon size={18} data-id="element-775" data-mp="36b1knx883unt" />
          Back to Home
        </Link>

        <div className="grid md:grid-cols-2 gap-16" data-id="element-776" data-mp="3b932yfxtrpy8">
          <div data-id="element-777" data-mp="3b7s0qkk12q98">
            <h1 className="text-4xl md:text-5xl font-black text-warmBrown mb-4 leading-tight" data-id="element-778" data-mp="3bbfthhhnf8mw">
              Join the{' '}
              <span className="text-peach" data-id="element-779" data-mp="2gmczahdplgcd">Pawchi Creator Program</span>
            </h1>
            <p className="text-warmBrown/80 text-lg mb-8 leading-relaxed" data-id="element-780" data-mp="2goh3l0fishd6">
              Love sharing your pet online? Get early access to Pawchi,
              exclusive perks, and earn money by creating content featuring your
              furry friend. Whether you're an established creator or just have a
              pet with a great personality, we'd love to partner with you!
            </p>

            <div className="bg-white rounded-3xl p-8 shadow-soft mb-8 border border-warmBrown/5" data-id="element-781" data-mp="2ckj0ken2qmeu">
              <h3 className="font-bold text-xl text-warmBrown mb-6" data-id="element-782" data-mp="27tswr5uaqrm9">
                Requirements
              </h3>
              <ul className="space-y-6" data-id="element-783" data-mp="1k3yhyiqf2szd">
                <li className="flex items-start gap-4" data-id="element-784" data-mp="1k2ngipkg1xbf">
                  <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-785" data-mp="1f5naufriawku">
                    <Dog size={20} data-id="element-786" data-mp="3qrp4ska156cg" />
                  </div>
                  <div data-id="element-787" data-mp="3vixfrkr0czrq">
                    <p className="font-bold text-warmBrown" data-id="element-788" data-mp="3vjh17bfva6ai">Own a dog or cat</p>
                    <p className="text-sm text-warmBrown/60" data-id="element-789" data-mp="3gukp93aow94m">
                      Your pet is the star of the show.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-790" data-mp="ddkpqquut6sh">
                  <div className="w-10 h-10 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-791" data-mp="de3ypi2j0kud">
                    <Smartphone size={20} data-id="element-792" data-mp="4cwc3x9dh8g4" />
                  </div>
                  <div data-id="element-793" data-mp="4ccw4m3a8u4q">
                    <p className="font-bold text-warmBrown" data-id="element-794" data-mp="4f8pry83kwnd">Smartphone</p>
                    <p className="text-sm text-warmBrown/60" data-id="element-795" data-mp="8cws3mc4drpa">
                      To record content and use the Pawchi app.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-796" data-mp="2t69yisypjpu2">
                  <div className="w-10 h-10 rounded-full bg-coral/10 text-coral flex items-center justify-center flex-shrink-0" data-id="element-797" data-mp="39cd43o4xc9lk">
                    <Camera size={20} data-id="element-798" data-mp="34kcypg634ohl" />
                  </div>
                  <div data-id="element-799" data-mp="2zls6o40zlb48">
                    <p className="font-bold text-warmBrown" data-id="element-800" data-mp="2zn3d6bltgwz1">
                      Willing to record videos
                    </p>
                    <p className="text-sm text-warmBrown/60" data-id="element-801" data-mp="2uos0lt4508d4">
                      Comfortable filming everyday moments.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-soft mb-8 border border-warmBrown/5" data-id="element-802" data-mp="3icjdoyxi4pfg">
              <h3 className="font-bold text-xl text-warmBrown mb-6" data-id="element-803" data-mp="3eay69t3ql3cn">Rewards</h3>
              <ul className="space-y-6" data-id="element-804" data-mp="3ed0uc7lbwmeq">
                <li className="flex items-start gap-4" data-id="element-805" data-mp="26xw3qhktqmz0">
                  <div className="w-10 h-10 rounded-full bg-sage/10 text-sage flex items-center justify-center flex-shrink-0" data-id="element-806" data-mp="26v9umdiabzeo">
                    <Gift size={20} data-id="element-807" data-mp="ie0b7dm070rv" />
                  </div>
                  <div data-id="element-808" data-mp="ifl5d24eohp7">
                    <p className="font-bold text-warmBrown" data-id="element-809" data-mp="mfbsmvuq4foz">Free Pawchi Plus</p>
                    <p className="text-sm text-warmBrown/60" data-id="element-810" data-mp="md94khd4swmw">
                      Get full access to all premium features.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-811" data-mp="w6g8ryw4y6le">
                  <div className="w-10 h-10 rounded-full bg-peach/10 text-peach flex items-center justify-center flex-shrink-0" data-id="element-812" data-mp="11519dzfausad">
                    <Percent size={20} data-id="element-813" data-mp="161rmcdvt57rk" />
                  </div>
                  <div data-id="element-814" data-mp="1a4egwmjv56sg">
                    <p className="font-bold text-warmBrown" data-id="element-815" data-mp="1a67r2btoq957">
                      Up to 20% affiliate commission!
                    </p>
                    <p className="text-sm text-warmBrown/60" data-id="element-816" data-mp="1f1n2kx47zsyg">
                      Earn money for every new user you bring in.
                    </p>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-817" data-mp="3gx797abhdxa2">
                  <div className="w-10 h-10 rounded-full bg-lavender/10 text-lavender flex items-center justify-center flex-shrink-0" data-id="element-818" data-mp="o1xd37g46uvr">
                    <TrendingUp size={20} data-id="element-819" data-mp="j3vtmles0tjr" />
                  </div>
                  <div data-id="element-820" data-mp="x2dca4ptrfut">
                    <p className="font-bold text-warmBrown" data-id="element-821" data-mp="x2vdlfrcgk9l">
                      Bonuses for top-performing videos
                    </p>
                    <p className="text-sm text-warmBrown/60" data-id="element-822" data-mp="16z882fupr25e">
                      Extra rewards when your content goes viral.
                    </p>
                  </div>
                </li>
              </ul>
            </div>

            <Link to="/creator/help" className="group block bg-gradient-to-br from-peach to-coral rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-shadow text-white" data-id="element-823" data-mp="1fqs24ooeonu1">
              <div className="flex items-center gap-3 mb-3" data-id="element-824" data-mp="1pqiv2lxbius0">
                <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center" data-id="element-825" data-mp="1krxx6t5jgn6q">
                  <BookOpen size={20} data-id="element-826" data-mp="24e9fdjye18tb" />
                </div>
                <p className="text-xs font-bold uppercase tracking-wider text-white/80" data-id="element-827" data-mp="29cksc3jzbzfr">
                  Creator Resources
                </p>
              </div>
              <h3 className="font-black text-xl mb-2" data-id="element-828" data-mp="1ugv0vpw0yu3n">Visit the Help Center</h3>
              <p className="text-white/90 text-sm leading-relaxed mb-4" data-id="element-829" data-mp="1zcaecgq4enzj">
                Guides, protocols, and tips to help you grow your audience and
                earn more with Pawchi.
              </p>
              <span className="inline-flex items-center gap-2 font-bold text-sm group-hover:gap-3 transition-all" data-id="element-830" data-mp="1qehxv98nxaak">
                Browse guides
                <ArrowRight size={16} data-id="element-831" data-mp="1gmuapkj52few" />
              </span>
            </Link>
          </div>

          <div className="relative" data-id="element-832" data-mp="12nuk47c2fqg3">
            <div className="bg-white rounded-[2.5rem] p-8 md:p-10 shadow-soft-lg border border-warmBrown/5 sticky top-32" data-id="element-833" data-mp="12ovxwjkgur1i">
              <h3 className="text-2xl font-bold text-warmBrown mb-2" data-id="element-834" data-mp="16rah54s1rstb">
                Apply Now
              </h3>
              <p className="text-warmBrown/60 text-sm mb-8" data-id="element-835" data-mp="1n2cjmxt8s4q4">
                Fill out the form below and our team will get back to you within
                48 hours.
              </p>

              {submitted ? <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="bg-sage/10 border border-sage/30 rounded-2xl p-6 text-center" data-id="element-836" data-mp="187oi1uqypqfs">
                  <div className="w-12 h-12 bg-sage/20 text-sage rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-837" data-mp="ugb3ywbtpks5">
                    <CheckCircle2 size={24} data-id="element-838" data-mp="khu8pn5uqk0a" />
                  </div>
                  <h4 className="font-bold text-warmBrown mb-2" data-id="element-839" data-mp="kh2cqb8cek9h">
                    Application Received!
                  </h4>
                  <p className="text-sm text-warmBrown/70" data-id="element-840" data-mp="2s3lzemrywhgq">
                    Thanks for applying to the Pawchi Creator Program. We'll be
                    in touch soon.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-6 text-sm font-bold text-peach hover:text-peach/80 transition-colors" data-id="element-841" data-mp="314adfhhd2htm">
                    Submit another application
                  </button>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-842" data-mp="2de66p18vm1ye">
                  {error && <div className="p-3 bg-coral/10 border border-coral/20 rounded-xl text-coral text-sm" data-id="element-843" data-mp="2idiv3qfebh33">
                      {error}
                    </div>}

                  <div data-id="element-844" data-mp="1ppelwuxm8lvn">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-845" data-mp="1po3ln53dpw9a">
                      Your Name
                    </label>
                    <input type="text" required value={formState.name} onChange={e => setFormState({
                  ...formState,
                  name: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="Jane Doe" data-id="element-846" data-mp="1ulvatrcn349s" />
                  </div>

                  <div data-id="element-847" data-mp="1ot7vfj5i4ug8">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-848" data-mp="1osy5fvkginaj">
                      Email Address
                    </label>
                    <input type="email" required value={formState.email} onChange={e => setFormState({
                  ...formState,
                  email: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="jane@example.com" data-id="element-849" data-mp="w63ov9qrg82c" />
                  </div>

                  <div data-id="element-850" data-mp="2vhx1gr49t0kr">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-851" data-mp="2qpm0dkxsn8qm">
                      What kind of pet do you have?
                    </label>
                    <input type="text" required value={formState.petType} onChange={e => setFormState({
                  ...formState,
                  petType: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="e.g. Golden Retriever, Calico Cat" data-id="element-852" data-mp="2mlo3lgvxya0q" />
                  </div>

                  <div data-id="element-853" data-mp="1t42p8izdkb8a">
                    <label className="block text-sm font-medium text-warmBrown/70 mb-2" data-id="element-854" data-mp="1t5m2e0pqi65u">
                      Primary Social Media Link
                    </label>
                    <input type="url" required value={formState.socialHandle} onChange={e => setFormState({
                  ...formState,
                  socialHandle: e.target.value
                })} className="w-full px-4 py-3 rounded-xl bg-cream/50 border border-warmBrown/10 text-warmBrown focus:outline-none focus:border-peach/50 focus:ring-1 focus:ring-peach/30 transition-colors" placeholder="https://tiktok.com/@yourhandle" data-id="element-855" data-mp="2lryjzi5dvt2f" />
                  </div>

                  <button type="submit" disabled={isLoading} className="w-full mt-4 px-8 py-4 rounded-full font-bold text-white bg-peach hover:bg-peach/90 disabled:opacity-70 disabled:cursor-not-allowed transition-colors shadow-soft-lg flex items-center justify-center gap-2" data-id="element-856" data-mp="12sh45cebrywf">
                    {isLoading ? 'Submitting...' : <>
                        Submit Application
                        <SendIcon size={18} data-id="element-857" data-mp="f6an60mxb8u2" />
                      </>}
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </div>;
}